import clsx from 'clsx';
import _ from 'lodash';
import { compose } from 'redux';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';
import { caseInsensitiveIncludes } from 'utils/string';

export const loanFeeCicFormFields = {
  cicFeeReasonId: {
    fieldId: 'cicFeeReasons',
    type: FieldType.SELECT,
    nameInModel: 'cicFeeReasons',
    inputProps: {
      multiple: true,
      options: [],
      label: 'CIC Fee Reason',
      placeholder: 'CIC Fee Reason',
      required: true,
      disableClearable: true,
      widthInColumns: 3,
      variant: 'outlined',
      optionName: 'normalizedName',
      isOptionEqualToValue: (option, { value }) => option.value === value,
      filterOptions: (options, { inputValue }) =>
        options.filter(
          ({ isDeleted, name }) => !isDeleted && caseInsensitiveIncludes(name, inputValue),
        ),
      getChipProps: cicFeeReasonReselectedIds => (option, tagProps) => ({
        ...tagProps,
        className: clsx(
          tagProps.className,
          !!cicFeeReasonReselectedIds[option.value] && 'autocomplete-chip-reselect',
        ),
      }),
    },
  },
  name: {
    type: FieldType.INPUT,
    nameInModel: 'loanCicFees[0].name',
    inputProps: {
      label: 'Name',
      placeholder: 'Name',
      required: false,
      disabled: true,
      widthInColumns: 2,
      variant: 'outlined',
    },
  },
  amount: {
    fieldId: 'amount',
    type: FieldType.INPUT,
    nameInModel: 'loanCicFees[0].amount',
    inputProps: {
      type: FieldInputType.CURRENCY,
      label: 'Amount',
      placeholder: 'Amount',
      required: false,
      variant: 'outlined',
      widthInColumns: 1,
      minValue: 0,
    },
  },
  feeTypeId: { nameInModel: 'loanCicFees[0].feeTypeId' }, // HACK_HACK: for reliable source in form
  isRequired: { nameInModel: 'loanCicFees[0].isRequired' },
  isDeleted: { nameInModel: 'loanCicFees[0].isDeleted' },
};

export const getLoanFeeCicFormConfig = compose(
  fillConfigFieldsWithKeys,
  ({
    loanCicFees,
    cicFeeReasonOptions = [],
    loanFees,
    onChangeCicFeeReason = _.noop,
    cicFeeReasonReselectedIds = {},
  }) => {
    return {
      groups: [
        {
          type: FieldType.GROUP,
          key: loanFeeCicFormFields.cicFeeReasonId.nameInModel,
          title: { className: 'order-before' },
          fields: [
            {
              ...loanFeeCicFormFields.cicFeeReasonId,
              inputProps: {
                ...loanFeeCicFormFields.cicFeeReasonId.inputProps,
                customOnChange: onChangeCicFeeReason,
                getChipProps:
                  loanFeeCicFormFields.cicFeeReasonId.inputProps.getChipProps(
                    cicFeeReasonReselectedIds,
                  ),
                options: cicFeeReasonOptions,
              },
            },
          ],
        },

        ...loanCicFees.map(({ isRequired, feeTypeId }, index) => {
          const isLoanFeeCustomDisabled = !!loanFees[feeTypeId]?.isCustomDisabled;

          return {
            type: FieldType.GROUP,
            fields: [
              {
                ...loanFeeCicFormFields.name,
                nameInModel: loanFeeCicFormFields.name.nameInModel.replace('[0]', `[${index}]`),
              },
              {
                ...loanFeeCicFormFields.amount,
                nameInModel: loanFeeCicFormFields.amount.nameInModel.replace('[0]', `[${index}]`),
                inputProps: {
                  ...loanFeeCicFormFields.amount.inputProps,
                  required: isRequired && !isLoanFeeCustomDisabled,
                  disabled: isLoanFeeCustomDisabled,
                },
              },
              {
                nameInModel: loanFeeCicFormFields.feeTypeId.nameInModel.replace(
                  '[0]',
                  `[${index}]`,
                ),
              },
              {
                nameInModel: loanFeeCicFormFields.isRequired.nameInModel.replace(
                  '[0]',
                  `[${index}]`,
                ),
              },
              {
                nameInModel: loanFeeCicFormFields.isDeleted.nameInModel.replace(
                  '[0]',
                  `[${index}]`,
                ),
              },
            ],
          };
        }),
      ],
    };
  },
);
